import { useRef, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { AppShell, BrandLink, ShellMain } from 'layout/AppShell';
import { PublicNavLinks } from 'navigation/TopNavigation';
import { MobileDrawer } from 'navigation/MobileDrawer';
import { IconMenu } from 'shared/assets/icons';
import { LanguageSwitcher } from 'shared/components/LanguageSwitcher';

export function PublicLayout() {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const menuButtonRef = useRef(null);

  return (
    <AppShell className="public-shell">
      <header className="site-header">
        <div className="shell-container header-inner">
          <BrandLink to={paths.welcome} />
          <PublicNavLinks className="public-nav" />
          <div className="header-end">
            <LanguageSwitcher />
            <Link className="btn btn-primary header-cta" to={paths.auth}>{t('actions.login')}</Link>
            <button
              ref={menuButtonRef}
              type="button"
              className="btn btn-icon menu-toggle"
              aria-expanded={open}
              aria-controls="public-drawer"
              aria-label={t('layout.openMenu')}
              onClick={() => setOpen(true)}
            >
              <IconMenu />
            </button>
          </div>
        </div>
      </header>
      <MobileDrawer
        open={open}
        onClose={() => setOpen(false)}
        restoreRef={menuButtonRef}
      />
      <ShellMain className="public-main">
        <div className="shell-container">
          <Outlet />
        </div>
      </ShellMain>
    </AppShell>
  );
}
